// 敏感词库
const sensitiveWords = [
  // 政治相关
  '政治', '政府', '国家', '主席', '总理', '书记',
  '共产党', '民主党', '革命', '示威', '游行', '抗议',
  '独立', '分裂', '颠覆', '暴动', '政变', '政权',
  '宪法', '宪政', '民主', '自由', '法轮功', '六四',
  '天安门', '法制', '维权', '反腐', '腐败', '贪污',
  '习近平', '李克强', '温家宝', '胡锦涛', '江泽民', '毛泽东',
  '邓小平', '两会', '人大', '政协', '中央', '国务院',
  '军委', '军方', '解放军', '武警', '警察', '公安',
  '特务', '间谍', '反党', '反革命', '文革', '文化大革命',
  '改革开放', '三权分立', '司法独立', '公民运动', '公民社会',
  // 地区相关
  '台湾', '香港', '澳门', '西藏', '新疆',
  '台独', '港独', '藏独', '疆独', '蒙独', '内蒙古',
  '达赖', '达赖喇嘛', '法轮', '法轮大法', '尊者',
  // 其他敏感词
  '反动', '暴力', '恐怖', '极端', '分裂', '颠覆',
  '民运', '自由', '人权', '维权', '上访',
  '集会', '结社', '言论自由', '新闻自由', '信仰自由',
  '审查', '言论审查', '网络审查', '防火墙', '翻墙',
  '网络封锁', '封锁信息', 'VPN', '代理', '梯子',
  '人民币', '货币贬值', '通货膨胀', '经济危机', '经济崩溃',
  '骚乱', '动乱', '屠杀', '镇压', '迫害', '逮捕',
  '监禁', '刑讯', '酷刑', '劳改', '洗脑', '思想改造',
  '思想政治', '政治觉悟', '政治学习', '政治运动', '阶级斗争',
  '资本主义', '社会主义', '共产主义', '马列主义', '毛泽东思想',
  '邪教', '异见', '异见人士', '持不同政见', '反体制',
  
  // 映射类敏感词（拼音缩写、谐音、数字替换等）
  // 拼音缩写
  'zf', 'zf1', 'ZF', 'gcd', 'GCD', 'tmzf', 'TMZF', 'zgzf',
  'zg', 'zgjf', 'tam', 'TAM', 'wjb', 'nmsl', 'xjp', 'lkq',
  'gfw', 'GFW', 'zjm', 'mzd', 'dzp', 'flg', 'FLG', 'zY',
  
  // 谐音和变种
  '真理部', '镇压', '和谐', '河蟹', '朝廷', '天朝', '皇帝',
  '祖国', '天下', '王朝', '帝国', '专政', '专制', '独裁',
  '封锁', '封杀', '和谐社会', '依法治国', '四项基本原则',
  '党国', '赵家人', '赵家', '权贵', '权势', '官僚', 
  '权力', '特权', '强拆', '截访', '维稳', '五毛', '五毛党',
  '自干五', '舆论战', '舆论引导', '意识形态', '红色', '红色江山',
  
  // 数字替换和符号变形
  '64', '89', '8964', '六4', '六④', '六肆', '⑥④', '陆肆',
  '8.9', '6.4', '六月四', '六月四日', '八九', '捌玖', 
  '习近*', '*近平', '习*平', 'X近平', '习JinPing', 'XJP',
  
  // 间隔符号绕过
  '民.主', '言.论', '自.由', '抗.议', '示.威', '颠.覆', 
  '封.杀', '和.谐', '河.蟹', '屏.蔽', '审.查', '民·主',
  '言·论', '自·由', '抗·议', '示·威', '颠·覆',
  
  // 英文变种和拼音
  'minzhu', 'ziyou', 'renquan', 'kangyi', 'shiwei', 'zhuanzheng',
  'duli', 'zhuanzhi', 'ducai', 'dixia', 'dixiajiaohui', 'dixiadang',
  'minyun', 'zhengbian', 'baodong', 'baoluan', 'qiangzhi',
  'democracy', 'freedom', 'humanrights', 'censorship', 'dictatorship',
  
  // 组合和缩写
  'NMSL', 'TMD', 'CNMB', 'SB', '共匪', '五毛', '美分', '精美',
  '精日', '恨国党', '公知', '港毒', '台毒', '藏毒', '圣母婊',
  '白左', '民运分子', '境外势力', '反华', '卖国', '汉奸', '美狗',
  
  // 网络黑话
  '赵弹', '秦城', '喝茶', '被喝茶', '被约谈', '被消失',
  '跨省', '寻衅滋事', '辱华', '辱尊', '递刀', '递刀子',
  '递刀片', '递刀子', '递🔪', '递🗡', '递菜刀', '递水果刀',
  
  // 怀念极左和文革相关表达
  '弱水三千', '文革余孽', '红色年代', '红色记忆', '红卫兵',
  '大串联', '大批判', '大鸣大放', '大字报', '破四旧',
  '武斗', '造反派', '走资派', '资产阶级', '修正主义',
  '革命小将', '毛左', '老红卫兵', '老造反', '打砸抢',
  '上山下乡', '知青', '再教育', '忆苦思甜', '样板戏',
  '语录', '红宝书', '红色经典', '毛主席语录', '毛主席万岁',
  '革命无罪', '造反有理', '斗私批修', '割资本主义尾巴',
  '大跃进', '大炼钢铁', '人民公社', '三面红旗', '四清运动',
  '清理阶级队伍', '忠字舞', '早请示', '晚汇报', '读语录',
  '背语录', '高举毛泽东思想伟大红旗', '无产阶级专政',
  '无产阶级文化大革命', '工宣队', '军宣队', '复辟', '走后门',
  '右倾', '左倾', '极左', '极左思潮', '极左路线',
  '革命委员会', '文革博物馆', '黑五类', '红五类',
  '狗崽子', '狗屁专家', '臭老九', '臭知识分子',
  '牛鬼蛇神', '牛棚', '批斗', '游街', '戴高帽',
  '江青', '四人帮', '反右', '反右扩大化', '大串联',
  '复课闹革命', '锦州事件', '黑龙江兵团', '小靳斋',
  
  // 网络热点事件和新敏感词
  'It\'s my duty', '麦丢替', '四月之声', '白纸', '白纸革命',
  '乌鲁木齐中路', '桥', '四通桥', '勇士', '清君侧', '人矿',
  '破防了', '躺平', '内卷', '画饼', '偷感', '润', '离岸爱国',
  '小粉红', '战狼', '加速主义', '加速师', '总加速师',
  '倒车', '开倒车', '三年清零', '动态清零', '辱包', '包子',
  '长津湖', '战狼外交', '长命百岁', '祈翠', '登基', '蜂蜜',
  '苦丁茶', '黑皮', '境外反华', '递国籍', '反诈',
  '沼气池', '赵蛋', '常委', '小学博士', '博士小学', '敏感的日子',
  
  // 六四相关特殊表达
  '35周年', '62+2', '达明一派', '自由花', '这是我的职责',
  '3 4 5 6 8 9', '坦克人', '坦克照片', '天安门母亲',
  '烛光', '点燃', '记忆', '不能忘记', '历史的伤口',
  
  // 更多网络术语和特殊表达
  '所罗门群岛', '特鲁多', '加拿大总理', '小土豆', '翠翠',
  '大熊猫翠翠', '薄瓜瓜', '退休时间', '延迟退休', '私企', 
  '民营企业', '中非论坛', '大撒币', '上海迪士尼噗噗熊',
  '芯片', '科技制裁', '台湾选举', '台湾大选', '冻蒜',
  '厄瓜多尔', '走线', '美引诱北京攻台', '表弟齐明',
  '陋习', '陋刃', '蓝灯', '无界', '莒县', '胰腺癌',
  '走线', '股灾', '缅A', '长颈鹿事件', '网红王大娟',
  '乐观向上', '整个国家都洋溢着乐观向上的氛围',
  '中国感恩节', '蛋炒饭节', '跪搜', '辱华',
  
  // 新型躲避审查方式
  'yyds', 'nsdd', 'xswl', 'plgg', 'pljj', 'bdjw', 
  'u1s1', 'srds', '永远的神', '你说得对', '笑死我了',
  '漂亮哥哥', '漂亮姐姐', '不懂就问', '有一说一',
  '虽然但是', '200斤饺子', 
  
  // 基于网络流行避讳的词汇
  '习以为常', '学习强国', '近平衡', '尊习重道',
  '吸精瓶', '西晋平', '刑平', '包子铺', '包帝',
  '蛤蟆', '蟹军', '蛤军', '膜蛤', '刁德一',
  '大撒币', '平衡针', '庆丰帝', '袁世凯', '慈禧',
  '李鹏', '李鹏之父', '李·培顿', '粥档', '黑帮大佬',
  '克林顿', '路易十六', '斯大林', '日记', '不差钱',
  '蛤蜊', '长者', '大裤衩', '大裤裆', '人生的经验',
  '撒胡椒面', '枪毙', '图样图森破', '坦克车', '坦克人',
  '六月飞雪', '刘晓波', '坚守阵地', '七八九',
  '主*席', '主_席', '主.席', '主X席', '主 席',
  '**平', 'Xi大大', 'X大大', '习爷爷', '习总',
  
  // 新增网络流行语和特殊表达2024
  '敏感瓷', '细软跑', '典中典', '麻了', '破防', '太君',
  '被社会毒打', '铁拳', '神友', '神蛆', '鼠人', '兔友',
  '圣上', '龙体', '摊丁入亩', '五谷轮回', '大撒币',
  '指鹿为马', '韭菜', '镰刀', '割韭菜', '韭菜本位',
  '绝绝子', '夹总', '抛开事实不谈', '毒菜', '皿煮',
  '滋油', '鹽輪籽油', '河蟹社会', '普世', '水产', 'SC',
  '茧中互联网', '冲塔', '加速', '总加速师', '逆民',
  '8平方', '4立方', '√4096', 'ⅥⅣ', '5月35日', '坦克节',  
  
  // 网络梗和古风表达
  '三个字母', '弱水三千', '汝之蜜糖', '彼之砒霜', '此间少年',
  '众生皆苦', '何不食肉糜', '朕已阅', '爱卿辛苦了',
  '春风得意马蹄疾', '一夫当关万夫莫开', '苟利国家生死以',
  '不以物喜不以己悲', '天不生我彭宇晶', '鲁迅说过',
  '毛选第五卷', '大抽风', '大健身', '大吃饱', '人肝大补',
  '弄璋之喜', '黄泥巴掉进裤裆', '大禹治水', '悲从中来',
  '盼忠臣', '谋逆', '清君侧', '反清复明', '万岁万岁万万岁',
  '御赐', '欺君之罪', '欺上瞒下', '尚方宝剑', '夜访',
  '批阅', '天子', '先斩后奏', '跪安', '皇恩浩荡',
  
  // 互联网流行词汇和特殊含义缩写
  'ZF', 'GOV', 'GFW', '功夫网', '墙', '翻墙', '穿墙', 
  '科学上网', 'CNMD', '中国网站维护日', '战略忽悠局',
  '战忽局', '局座', '民主之后杀全家', '民杀家', '民杀全',
  '炸药奖', '一国两智', '伊法治国', '冻蒜', 
  '这届人民不行', '宽衣解带', '按闹分配', '霉体', '妓者',
  '砖家', '叫兽', '跪搜', '岁静', '粉红', '兔杂',
  
  // 历史/地域敏感性表达
  '大东亚共荣圈', '大东亚圣战', '日杂', '精日', '白左',
  '圣母婊', '绿绿', '咖啡乐', '天龙人', '母人', '幕刃',
  '郭楠', '蝈蝻', '毛左', '左人', '佐壬', '网左', '安人', 
  '安壬', '安康', '安资', '无政资', '工业党', '入关人',
  '入关壬', '精苏', 'Tankie', '出口转内销', '实锤',
  
  // 字母缩写和特殊表达
  'DLLM', 'GJJM', 'QNMLGB', 'CNM', 'TMD', 'TNC', 'WNR', 
  'SB', 'NMB', 'TM', 'BI', 'WTF', 'FU', 'FUCK', 
  'STFU', 'JB', 'DB', '尼玛', '泥马', '草', '艹', '屮',
  '我去', '靠', '卧槽', '我艹', '日', '啪啪啪',
  
  // 综艺节目相关敏感词
  '101', '创造101', '偶像练习生', '青你', '青春有你',
  '造星计划', '限流令', '饭圈', '粉丝应援', '打投',
  '控评', '私生', '私生饭', '饭圈女孩', '应援色',  
  
  // 文革相关人物代号和别称
  '黄轩', '黄轩代指王洪文', '文革人物代号', '王张江姚', '王洪文', 
  '张春桥', '江青', '姚文元', '四人帮', '四人小宗派', 
  '江青反革命集团', '工总司', '一月风暴', '康平路事件',
  '王张江姚反党集团', '王、关、戚事件', '杨、余、傅事件',
  '五一六反革命阴谋集团', '彭罗陆杨反党集团',
  '安亭事件', '文革主犯', '批邓、反击右倾翻案风',
  '林彪、江青反革命集团案', '批林批孔', '三家村',
  '工人造反派', '习正日', '习尔布特', '习索里尼',
  '腊肉馅儿包子', '习猪头', '习猪席', '习猪下台',
  '习是春竹', '习是春绿', '习king', '习emperor',
  '习驴', '习付', '习太孑', '习猪',
  '毛二世', '毛二习', '习泽东', '习大林',
  
  // 习近平相关敏感词
  '习敗敗', '习敗北', '宽衣撸绣单肩扛麦光腚拉碾歪脖撒币小学博士帝',
  '倒车斯基', '读稿机', '灰习牛', '疯狂宇宙包', '尊蛤讨包',
  '背书单', '专治各种不服', '世界最强乞丐', '习大犬',
  '西朝鲜人民自治岛', '习核心', '习思想', '东方project',
  '吃赵弹', 'ChinaXi', '亲自删评', '亲自封号', '赛禁评',
  '集金pay', '集金币', '集近闭', 'shuu kinn pei',
  '爱新觉罗近平', '习蛤', '梁家河贵族', '相信有神论的物理学博士',
  '习兵法', '韦来书记', '刁近猴', '普习金', '富平学霸刁斤干',
  '习进棺', '刁斤山', '刁斤二', '庆丰包·勃列日涅夫',
  '刁远山', '习猪席', '毛二习', '包禁评', '习总输记',
  '领袖习澡水', '核平全世界', '彭主席（习主席走了太太接班）',
  '包子兵法', '冠子兵法', '席子兵法', '习殡法', '习病法',
  '习下台', 'nmslman（习主席）', 'Heil Xitler', '那翠化',
  '习孢子', 'shit hole bing fa', '粪坑兵法', '灭共助推器',
  'Corona Xi（习病毒）', '维尼快乐组织（Winnie Happy Organization）简称WHO',
  '坟头蹦迪', '习屎黄', '习瘟猪', '小习微信', '刁人13',
  '赵人13', '贬词包用', '文明其精神', '野蛮其体魄',
  '野兽主席', '亲自考察', '亲自脱贫', '糖尿维尼',
  '维尼带货', 'CoronaXi', 'Chairman Xi',
  'Criminal Xi "Xitler" Jinping', '习狍', '玉习大帝',
  '包皇', '赵付', '撒币宝', '维尼警察（X）',
  '维稳警察（O）', '赵家家仆', '刁后主', '习后主',
  '习 卡 巴 卡', '儿童习典', '习二二（二零二零年五月二十二日开二会）',
  '习呆呆', '习二蛋', 'nmslese dream', '維尼頌', '帝皇頌',
  '叼斤干', '习近砰', '影子末帝', '祈翠語言包', '习习蛤蛤',
  '大撒幣',
];

/**
 * 检查文本中是否包含敏感词
 * @param {string} text 要检查的文本
 * @returns {string[]} 找到的敏感词列表
 */
export const checkSensitiveWords = (text) => {
  if (!text) return [];
  const foundWords = [];
  
  // 转换为小写进行检查，提高检测率
  const lowerText = text.toLowerCase();
  
  for (const word of sensitiveWords) {
    // 对原始文本和小写文本都进行检查
    if (text.includes(word) || (lowerText.includes(word.toLowerCase()) && word !== word.toLowerCase())) {
      foundWords.push(word);
    }
  }
  
  return foundWords;
};

/**
 * 过滤中文输入中的非法字符
 * @param {string} value 输入值
 * @returns {{filteredValue: string, isFiltered: boolean}} 过滤后的值和是否被过滤的标志
 */
export const filterChineseInput = (value) => {
  // 允许中文、英文、数字和常见标点
  const validChars = value.replace(/[^\u4e00-\u9fa5\w\s.,!?'"\-_:;()[\]{}#@%&*+=<>/\\$^|~]/g, '');
  return {
    filteredValue: validChars,
    isFiltered: validChars !== value
  };
};

/**
 * 过滤英文输入中的非法字符
 * @param {string} value 输入值
 * @returns {{filteredValue: string, isFiltered: boolean}} 过滤后的值和是否被过滤的标志
 */
export const filterEnglishInput = (value) => {
  // 允许英文字母、数字、空格和常见标点符号
  const validChars = value.replace(/[^\w\s.,!?'"\-_:;()[\]{}#@%&*+=<>/\\$^|~]/g, '');
  return {
    filteredValue: validChars,
    isFiltered: validChars !== value
  };
};

// 导出敏感词列表
export { sensitiveWords };

// 默认导出所有功能
export default {
  sensitiveWords,
  checkSensitiveWords,
  filterChineseInput,
  filterEnglishInput
}; 